import { Action, Border } from "../../../foundations/palette.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
import { FontSize, FontWeight, LetterSpacing } from "../../../foundations/typography.es.js";
const accordionStyleOverrides = {
  root: {
    fontSize: FontSize["xs"],
    fontWeight: FontWeight["medium"],
    letterSpacing: LetterSpacing["widerMedium"],
    boxShadow: "none",
    border: `1px solid ${Action.focus}`,
    borderRadius: `${Spacing["750"]} !important`,
    ":hover": {
      borderColor: Border.dark
    },
    ":before": {
      content: "none"
    }
  }
};
export {
  accordionStyleOverrides
};
//# sourceMappingURL=accordion.es.js.map
